import { KeyValuePipe, UpperCasePipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, signal, ViewEncapsulation } from '@angular/core';
import { MatFormField } from '@angular/material/input';
import { MatDivider } from '@angular/material/list';
import { MatMenu, MatMenuItem, MatMenuTrigger } from '@angular/material/menu';
import { MatOption, MatSelect } from '@angular/material/select';
import { TranslatePipe } from '@ngx-translate/core';

import { CelumIcon, IconConfiguration } from '@celum/common-components/icon';
import { CelumFormFieldDirective } from '@celum/common-components/inputs';
import { LanguagePipe } from '@celum/ng2base/translation';

import { Avatar } from '../../model/avatar/avatar';
import { Languages } from '../../model/languages';
import { User } from '../../model/user/user';

@Component({
  selector: 'systembar-avatar',
  templateUrl: './avatar-component.html',
  styleUrls: ['./avatar-component.less'],
  imports: [
    MatMenu,
    MatMenuTrigger,
    CelumFormFieldDirective,
    MatFormField,
    MatSelect,
    TranslatePipe,
    MatOption,
    KeyValuePipe,
    LanguagePipe,
    UpperCasePipe,
    MatMenuItem,
    MatDivider,
    CelumIcon
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  host: {
    class: 'systembar-avatar',
    '[class.celum-systembar_components--active]': 'isMenuOpen()'
  }
})
export class AvatarComponent {
  @Input() public avatar: Avatar;

  @Input() public languages: Languages;

  @Input() public user: User;

  protected isMenuOpen = signal(false);

  public logOutIconConfiguration = new IconConfiguration('logout').withIconDimensions(20, 20);

  public selectClicked(event: Event): void {
    event.stopPropagation();
  }
}
